import router from '@/router/index';
export default function goBackLogin() {
    localStorage.removeItem('token');
    router.push('/');
}
